<template>
<header class="qb-color-1">
    <div class="logo">
        <router-link to='/'><img alt="Vue logo" src="@/assets/logo.png"></router-link>
    </div>
    <form class="search" v-on:submit.prevent="buscarProduto">
        <div class="input-search">
            <input type="text" v-model="busca" placeholder="Buscar produtos..." />
            <button class="search-ico" style="height: 33px;" ><search class="md-28 white"/></button>
        </div>
    </form>
    <div class="menu-desktop">
      <div class="home">
        <router-link to="/"><span><Home title="Início" class="md-36 white" /></span></router-link>
      </div>
      <div v-if="this.loginVendedor" style="color:white;">
        <Account style="cursor:pointer;"  @click="openEditWindow();" class="md-36 white" />
        {{ userName.toUpperCase() }}
      </div>
      <div class="cart" style="order: 0;">
        <router-link to="/carrinho"><span><basket title="Carrinho" class="md-36 white"/></span></router-link>
      </div>
      <div class="user" style="order: 1;">
        <v-popover offset="16" >
          <avatar :username="userName" :size=36></avatar>
          <template slot="popover">
            <div>
              <span>Bem vindo! {{ userName }}</span>
              <ul style="list-style: none;">
                <li>Crédito: {{ credito ? priceFormater(credito) : '0,00' }}</li> 
                <li v-if="vendedor">&nbsp;</li> 
                <li v-if="vendedor">Vendedor: {{ vendedor }}</li> 
                <li v-if="telefone">Telefone: {{ telefone }}</li> 
                <li>&nbsp;</li> 
                <li v-if="this.gestor =='S'">
                  <router-link style="color:white;" to='/acessos'> 
                    Acessos
                  </router-link>
                </li>
                <li  @click="logout()">
                 <span style="color:#fff;cursor: pointer;">Sair</span>
                </li>
              </ul>
            </div>
          </template>
        </v-popover>
        
      </div>
      <div class="orders">
        <router-link to='/ultimos-pedidos'><span ><Receipt title="Últimos Pedidos" class="md-36 white" /></span></router-link>
      </div>
    </div>
    <modal key="edit" name="edit" v-if="this.loginVendedor" :adaptive="true" height="auto" :resizable="true" :scrollable="true"  style="padding:10px;" display="block">
      <div class="vinculo">
        <p style="font-weight: 600;font-size: 20px;margin-left:20px;">VINCULAR CLIENTE</p>    
        <v-select v-model="selected" :options="options" :value="$store.myValue" @input="ClienteUser">
        </v-select>  
        </br>  
        <v-select v-if="this.selected.id != 0" v-model="selectedUser" :options="clienteUsers" :value="$store.myValue" @input="SetCliente">
        </v-select>  
      </div>
    </modal>
    <div class="clienteVinculado white" style="cursor:pointer;"  @click="openEditWindow();" >
      <Account/> {{this.userName}}
    </div>
</header>
</template>

<script>
//import axios from 'axios';
import Basket from "vue-material-design-icons/Basket.vue";
import Home from "vue-material-design-icons/Home.vue";
import Search from "vue-material-design-icons/Magnify.vue";
import Receipt from "vue-material-design-icons/Receipt.vue";
import Avatar from 'vue-avatar';
import Account from "vue-material-design-icons/Account.vue";
import {userKey, baseApiUrl} from '@/global';
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select';
import axios from 'axios';

export default {
  name: 'Header',
  components:{
    Basket,
    Search,
    Avatar,
    vSelect,
    Home,
    Account,
    vSelect,
    Receipt
  },
  data(){
    return{
       userName: '',
       gestor:'',
       busca: '',
       credito: 0,
       loginVendedor : false,
       vendedor: '',
       vendedorID: 0,
       telefone: '',
       selected: {label:'Selecione um Cliente', id:0},
       selectedUser: {label:'Selecione um Usuário', id:0},
       optionsPronto: false,
       options: [],
       usuarios: [],
       clienteUsers: [],
    }
  },
  methods:{
    buscarProduto(){
      if(this.busca)
        this.$router.push({ name: 'lista', query:{ 
          marcas: '',//this.$route.query.marcas, 
          params: this.busca, 
          pagina: 1,
          idCategoria: '',//this.$route.query.idCategoria,
          ofertas: '',//this.$route.query.ofertas,
          novidades: '',//this.$route.query.novidades
          }})
      this.busca = "";
    },
    openEditWindow(){
      this.$modal.show('edit');
    },
    closeModal(){
      this.$modal.hide('edit');
     },
     SetCliente ()
    {
      const jsonVendedor = JSON.parse(localStorage.getItem('vendedor'));
        this.vendedorID = jsonVendedor.codeVendedor;
      var client = {id : this.selected.id, codeVendedor : this.vendedorID };
      axios.post(`${baseApiUrl}/login/setCliente`, client)
      .then(resp => {
        console.log(resp);
          if(resp.data.autenticated){    
              localStorage.setItem('cliente_usuario_vinculado', JSON.stringify({"id": this.selectedUser.id, "nome": this.selectedUser.nome}));                
              localStorage.removeItem(userKey);
              this.$store.commit('setUser', resp.data);
              localStorage.setItem(userKey, JSON.stringify(resp.data));
          } else if(!resp.data.autenticated) {
              const jsonVendedor = JSON.parse(localStorage.getItem('vendedor'));
              
              jsonVendedor.customerId = cliente.id;
              jsonVendedor.userName = cliente.nome;

              this.$store.commit('setUser', JSON.stringify(jsonVendedor));
              localStorage.setItem(userKey, JSON.stringify(jsonVendedor));
              
          }
          location.href ="https://ecommerce.tropicalimport.com.br/";
      }).catch(err => {
          this.$awn.alert('Problema selecionar este cliente, tente novamente', err, {labels: {alert: 'Erro' }});
          this.show=false
      }); 

    },
    ClienteUser ()
    {
        if(this.clienteUsers.length>1){
            this.clienteUsers = [];
        }
        axios.get(`${baseApiUrl}/login/clienteUsers/?clienteId=${this.selected.id}`)
                    .then(v => {
                        this.usuarios = v.data;
                        this.usuarios.forEach(element => {
                            this.clienteUsers.push({'label': element.nome + ' (' + element.login + ')'  , 'id': element.id, 'nome': element.nome});
                        });
                        if(this.clienteUsers.length<1){
                            this.$awn.warning('cliente não possui usuarios vinculados.', {labels: {warning: 'Atenção' }});
                        }
                        this.optionsPronto = true;
                    });
    },
    priceFormater(valor){
      return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    logout(){
      localStorage.removeItem(userKey);
      localStorage.removeItem('cliente_vinculado');
      localStorage.removeItem('cliente_usuario_vinculado');
      localStorage.removeItem('vendedor');
      this.$store.commit('removeUser');
      this.$router.push({name: 'home'});
    }
  },
  created(){
    const json = localStorage.getItem(userKey);
    const userData = JSON.parse(json);
    this.loginVendedor = (userData.typeAccess == 'V' || localStorage.getItem('vendedor') ? true : false);

    if(this.loginVendedor && !localStorage.getItem('vendedor')){
      localStorage.removeItem(userKey);
      localStorage.removeItem('vendedor');
      this.$store.commit('removeUser');
      this.$router.push({name: 'home'});
    }

    if(this.loginVendedor){
      if(localStorage.getItem('vendedor')){
        const jsonVendedor = JSON.parse(localStorage.getItem('vendedor'));
        this.vendedorID = jsonVendedor.codeVendedor;
        axios.get(`${baseApiUrl}/login/clientes/?userId=${this.vendedorID}`)
        .then(v => {
            this.usuarios = v.data;
            this.usuarios.forEach(element => {
                this.options.push({'label': element.id + ' ' + element.description  , 'id': element.id, 'nome': element.description});
            });
            if(this.options.length<1){
                this.$awn.warning('Você não possui clientes vinculados a você.', {labels: {warning: 'Atenção'}});
            }
            this.optionsPronto = true;
        });     
      } 
    }

    this.userName = userData.userName;
    this.credito = userData.credit;
    this.vendedor = userData.vendedor;
    this.telefone = userData.telefone;
    this.gestor = userData.gestor;
  }
}
</script>

<style >
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #20b1aa;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.clienteVinculado{
    display: none;
    text-align:right;
    font-size: 20px;
    margin-left: auto;
    margin-right: 5px;
    color: #fff;
  }

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #20b1aa;
  color: #fff;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, .1);
}

.tooltip.popover .popover-arrow {
  border-color: #20b1aa;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}

.cart{
  display: inherit;
  order:2;
}
.user{
  display: flex;
  align-items: center;
}
.orders{
  display: flex;align-items: center;font-size: 14px; font-weight: 700;
}
header{
  display: flex;
  align-items: center;
  justify-content: center;
  /*background-image: url('~@/assets/peixes-top.png');*/
  background-repeat: no-repeat;
  background-position: right;
}

.logo{
  text-align: center;
  padding: 0.5em;
}

.logo img{
  width: 100px;
}

.search{
  width: 45%;
  background-color: none;
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.input-search{
    width: 95%;
    display: flex;
    align-items: center;
}

.input-search input{
  padding-left: 16px;
  width: 100%;
  border:none;
  border-radius: 2px 0 0px 2px;
  height: 33px;
}

.material-design-icon.md-36 {
  font-size: 36px;
  height: 0.85em;
}

.material-design-icon.md-28 {
  font-size: 28px;
  height: 0.85em;
}

.white{
  color: #fff
}

.search-ico{
  border: none;
  background-color: #20B1AA;
}
.menu-desktop{
  display: flex;justify-content: space-between;min-width: 250px;
  align-items: center;
}
@media screen and (max-width: 900px){
  .search{
    background-color: #20B1AA;
    width: 100%;
    padding: 16px;
  }

  .input-search{
    width: 100%;
  }
  header{
    display: inherit;
  }
  .cart{
    display: none;
  }

  .search-ico{
    background-color: #25365C;
    border: 1px solid #25365C;
  }
}

@media screen and (max-width: 900px) and (min-width: 600px) {
 
  .logo img{
    max-height: 100px;
  }
}

@media screen and (max-width: 900px) {
 .menu-desktop{
   display: none;
 }
 .color-bg{
   background-color: #20B1AA;
 }
}
</style>